import React from 'react';
import { useQuery } from 'utils/react-query';

import Loader from 'components/uiLibrary/Loader';

import queries from 'containers/Productions/queries';

import classes from './FeaturedProductions.module.scss';

const FeaturedProductions = ({ filters, limit = 10, renderHeader, renderSlug }) => {
  const { data, isLoading } = useQuery(queries.getProductions({ filters, limit }));

  if (typeof renderSlug !== 'function' || data?.data?.length === 0) {
    return null;
  }

  if (isLoading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <>
      {renderHeader && renderHeader()}
      <div>
        {data?.data?.map(production => (
          <div key={production?.id} className={classes.production}>
            {renderSlug({ production })}
          </div>
        ))}
      </div>
    </>
  );
};

export default FeaturedProductions;
